import {
  isApiPaymentRequiredStatus,
  isApiTooManyRequestsStatus,
} from '../../utils/api'

export function getAIGretaErrorNotificationText(error, t) {
  const status = error?.response?.status

  if (isApiPaymentRequiredStatus(status)) {
    return t('Error.AILimitReachedErrorKey')
  }

  if (isApiTooManyRequestsStatus(status)) {
    return t('AITextGeneration.RateLimitErrorKey')
  }

  return t('Wizard.AIWizardGenericErrorKey')
}
